import { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Paper } from '@mantine/core';
import { FullHeadPane } from '../../Molecules/Pane';
import Pagination from '../../Atoms/Pagination';
import { fetchEmails, searchEmails } from '../../Service/restapi/messageService';
import EmailList from '../../Organismns/Message/EmailList';
import NewEmail from '../../Organismns/Message/NewEmail';
import { useQuery } from '../../Helpers/UrlQuery';
import { MessageContext } from '../../Service/Context/MessageContext';
import EmailMasterDetail from './EmailMasterDetail';

export const EmailBox = ({
  contactIds,
  event,
  customer,
  eventLocation,
  customAttributeValues,
  refreshEvent,
}) => {
  const [page, setPage] = useState(0);
  const [countOfPages, setCountOfPages] = useState(0);
  const [messages, setMessages] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [emailAction, setEmailAction] = useState();
  const { box, filter } = useParams();

  const query = useQuery();
  const queryString = query.get('query');

  useEffect(() => {
    setLoading(true);
    if (queryString) {
      searchEmails(queryString)
        .then((resp) => {
          if (resp.ok) {
            resp.json().then((emails) => {
              setMessages(emails);
            });
          } else {
            console.error(`could not search emails by search-string ${queryString}`);
          }
        })
        .catch((error) => {
          console.error(`could not search emails by search-string ${queryString}`);
          console.error({ error });
        })
        .then(() => {
          setLoading(false);
        });
    } else {
      fetchEmails(box, filter, page, contactIds)
        .then((resp) => {
          if (resp.status === 200) {
            setCountOfPages(resp.headers.get('Total-Count'));
            resp.json().then((emails) => {
              if (window.location.pathname.includes(box)) {
                if (filter) {
                  if (window.location.pathname.includes(filter)) {
                    console.log(`set ${emails.length} loaded mails on page ${window.location.pathname}`);
                    setMessages(emails.reverse());
                  } else {
                    console.log(`ignore loaded mails from ${resp.url} due to wrong page ${window.location.pathname}`);
                  }
                } else {
                  console.log(`set ${emails.length} loaded mails on page ${window.location.pathname}`);
                  setMessages(emails.reverse());
                }
              } else {
                console.log(`ignore loaded mails from ${resp.url} due to wrong page ${window.location.pathname}`);
              }
            });
          } else {
            console.error('could not load emails');
          }
        })
        .catch(() => {
          console.error('could not load emails');
        })
        .then(() => {
          setLoading(false);
        });
    }
  }, [box, filter, page, queryString]);

  const changeEmailById = (id, patch) => {
    const index = messages.findIndex((email) => email.id === id);
    const newEmails = Object.assign([], messages);
    if (index > -1) {
      if (!patch) {
        // email deleted
        newEmails.splice(index, 1);
      } else if (patch.trash !== newEmails[index].trash) {
        newEmails.splice(index, 1);
      } else {
        console.log('change email with patch', patch);
        let obj;
        for (obj in patch) {
          if (patch[obj] === null) {
            patch[obj] = undefined; // null values should not override (e.g. personDescription)
          }
        }
        newEmails[index] = {
          ...newEmails[index],
          ...patch,
        };
      }
    } else {
      console.log(`new email with id ${id} found`);
      if (typeof refreshEvent === 'function') {
        refreshEvent();
      }
      if (box === 'outbound') {
        newEmails.unshift(patch);
      }
    }
    setMessages(newEmails);
  }

  const styles = {
    noEmailSelected: {
      marginTop: 100,
      marginBottom: 100,
      fontSize: '0.875rem',
      textAlign: 'center',
    },
    head: {
      flex: 1,
      display: 'flex',
    },
    masterDetail: {
      display: 'flex',
    },
    displayEmail: {
      marginLeft: 10,
      flex: 1,
    },
  };

  return (
    <Paper shadow="xs" p="xl" radius="md" style={{ padding: 10 }}>
      <EmailMasterDetail
        emails={messages}
        changeEmailById={changeEmailById}
        emailAction={emailAction}
        setEmailAction={setEmailAction}
        isLoading={isLoading}
        event={event}
        page={page}
        setPage={setPage}
        countOfPages={countOfPages}
      >
        {/* TODO: load event, customer and eventLocation if not in concrete event */}
        <NewEmail
          event={event}
          customer={customer}
          eventLocation={eventLocation}
          customAttributeValues={customAttributeValues}
        />
        <EmailList event={event} eventLocation={eventLocation} />
      </EmailMasterDetail>
    </Paper>
  );
};

export const EmailBoxUrlProxy = EmailBox;
